// USES getVariantIdFromUrl() and GdcAddBundleToCart() in global.js

function handleLabelsAddon(event) {
  event.preventDefault()
  event.stopPropagation()

  const addonCheckbox = document.querySelector('#labels-add-on-checkbox')
  const productId = event.target.dataset.productId
  const selectedVariantId = getVariantIdFromUrl()
  const customLabelsAddonProductId = '45252505960646'

  const productItem = {
    id: selectedVariantId ? selectedVariantId : productId,
    quantity: 1,
  }

  const customLabelsItem = {
    id: customLabelsAddonProductId,
    quantity: 1,
  }

  const items = addonCheckbox.checked ? [productItem, customLabelsItem] : [productItem]

  GdcAddBundleToCart(items)
}
